import { render, staticRenderFns } from "./FirstRunInfo.vue?vue&type=template&id=12d7c8f3&scoped=true&lang=html&"
import script from "./FirstRunInfo.vue?vue&type=script&lang=js&"
export * from "./FirstRunInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7c8f3",
  null
  
)

export default component.exports